import { useState } from 'react';
import AdminKpiRecordService from './AdminKpiRecordService';

function useManageAdminKpiRecords() {
    const [kpiRecords, setKpiRecords] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshKpiRecords = async (params = {}) => {
        setIsLoading(true);
        try {
            const response = await AdminKpiRecordService.getAdminKpiRecords(params);
            setKpiRecords(response.data || []);
            setError(null);
        } catch (err) {
            console.log(err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const addKpiRecord = async (kpiRecordData) => {
        let result = true;
        setIsLoading(true);
        try {
            await AdminKpiRecordService.addAdminKpiRecord(kpiRecordData);
            refreshKpiRecords();
        } catch (err) {
            result = false;
            setError(err.response?.data?.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result;
    };

    const editKpiRecord = async (kpiRecordId, updatedData) => {
        setIsLoading(true);
        try {
            await AdminKpiRecordService.editAdminKpiRecord(kpiRecordId, updatedData);
            refreshKpiRecords();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const deleteKpiRecord = async (kpiRecordId) => {
        setIsLoading(true);
        try {
            await AdminKpiRecordService.deleteAdminKpiRecord(kpiRecordId);
            refreshKpiRecords();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        kpiRecords,
        isLoading,
        error,
        addKpiRecord,
        editKpiRecord,
        deleteKpiRecord,
        refreshKpiRecords
    };
}

export default useManageAdminKpiRecords;

